import { DefaultTransactionColumnHeader } from "./DefaultTransactionColumnHeader";
import { TransactionColumn } from "./TransactionColumn";
import { TransactionColumnSizer } from "./TransactionColumnSizer";
import { TransactionColumnFilterCategory } from "./TransactionColumnFilterCategory";

export function TransactionColumnHeaderCategory(): JSX.Element {
  return (
    <TransactionColumnSizer column={TransactionColumn.CATEGORY}>
      <DefaultTransactionColumnHeader
        column={TransactionColumn.CATEGORY}
        text={"Category"}
        FilterType={TransactionColumnFilterCategory}
      />
    </TransactionColumnSizer>
  );
}
